




















import Vue from 'vue';
interface Point {
  y: number;
  time: number;
}
const getMax = (offset: number, rowHeight: number) => offset * rowHeight;

/**
 * get min translate
 * @param offset
 * @param rowHeight
 * @param length
 * @returns {number}
 */
const getMin = (offset: number, rowHeight: number, length: number) => -(rowHeight * (length - offset - 1));
export default Vue.extend({
  props: ['items', 'temp'],
  data() {
    const points: Point[] = [];
    return {
      translate: 0,
      transitionTime: 0,
      offset: 2, // 列表初始化时的偏移量（列表初始化时，选项是聚焦在中间的，通过offset强制往上挪3项，以达到初始选项是为顶部的那项）
      rowHeight: 48, // 列表每一行的高度
      bodyHeight: 5 * 48,
      start: 0,
      end: 0,
      startTime: +new Date(),
      points,
      curTranslate: 0,
      curTransitionTime: 0,
    };
  },
  computed: {
    groupCss(): any {
      return {
        '-webkit-transform': `translate3d(0, ${this.curTranslate}px, 0)`,
        transform: `translate3d(0, ${this.curTranslate}px, 0)`,
        '-webkit-transition': `all ${this.curTransitionTime}s`,
        transition: `all ${this.curTransitionTime}s`,
      };
    },
  },
  watch: {
    temp() {
      this.initTranslate();
    },
  },
  created(): void {
    this.initTranslate();
  },
  methods: {
    getDefaultTranslate(offset: number, rowHeight: number, items: number) {
      const currentIndex = this.getDefaultIndex(items);
      return (offset - currentIndex) * rowHeight;
    },
    onChange(item: any, index: number) {
      this.$emit('onChange', item, index);
    },
    getDefaultIndex(items: any) {
      let current = Math.floor(items.length / 2);
      let count = 0;
      while (!!items[current] && items[current].disabled) {
        // eslint-disable-next-line no-plusplus
        current = ++current % items.length;
        count += 1;

        if (count > items.length) {
          throw new Error('No selectable item.');
        }
      }

      return current;
    },
    initTranslate(): void {
      if (this.temp !== null && this.temp < this.items.length) {
        const index = this.temp;
        this.onChange.call(this, this.items[index], index);
        this.translate = (this.offset - index) * this.rowHeight;
      } else {
        const index = this.getDefaultIndex(this.items);
        this.onChange.call(this, this.items[index], index);
        this.translate = this.getDefaultTranslate(
          this.offset,
          this.rowHeight,
          this.items,
        );
      }
      this.setTranslate(this.translate);
    },
    $$start(pageY: number) {
      this.start = pageY;
      this.startTime = +new Date();
    },
    setTransition(time: number) {
      this.curTransitionTime = time;
    },
    setTranslate(translate: number) {
      this.curTranslate = translate;
    },
    $$move(pageY: number) {
      this.end = pageY;
      const diff = this.end - this.start;
      this.setTransition(0);
      this.setTranslate(this.translate + diff);
      this.startTime = +new Date();
      this.points.push({ time: this.startTime, y: this.end });
      if (this.points.length > 40) {
        this.points.shift();
      }
    },
    $$end(pageY: number) {
      if (!this.start) {
        return;
      }

      /**
       * 思路:
       * 0. touchstart 记录按下的点和时间
       * 1. touchmove 移动时记录前 40个经过的点和时间
       * 2. touchend 松开手时, 记录该点和时间. 如果松开手时的时间, 距离上一次 move时的时间超过 100ms, 那么认为停止了, 不执行惯性滑动
       *    如果间隔时间在 100ms 内, 查找 100ms 内最近的那个点, 和松开手时的那个点, 计算距离和时间差, 算出速度
       *    速度乘以惯性滑动的时间, 例如 300ms, 计算出应该滑动的距离
       */
      const endTime = new Date().getTime();
      // @ts-ignore
      const relativeY = this.$refs.dom.getBoundingClientRect().top + this.bodyHeight / 2;
      this.end = pageY;

      // 如果上次时间距离松开手的时间超过 100ms, 则停止了, 没有惯性滑动
      if (endTime - this.startTime > 100) {
        // 如果end和start相差小于10，则视为
        if (Math.abs(this.end - this.start) > 10) {
          this.$$stop(this.end - this.start);
        } else {
          this.$$stop(relativeY - this.end);
        }
      } else {
        if (Math.abs(this.end - this.start) > 10) {
          const endPos = this.points.length - 1;
          let startPos = endPos;
          for (
            let i = endPos;
            i > 0 && this.startTime - this.points[i].time < 100;
            i--
          ) {
            startPos = i;
          }

          if (startPos !== endPos) {
            const ep = this.points[endPos];
            const sp = this.points[startPos];
            const t = ep.time - sp.time;
            const s = ep.y - sp.y;
            const v = s / t; // 出手时的速度
            const diff = v * 150 + (this.end - this.start); // 滑行 150ms,这里直接影响“灵敏度”
            this.$$stop(diff);
          } else {
            this.$$stop(0);
          }
        } else {
          this.$$stop(relativeY - this.end);
        }
      }

      this.start = 0;
    },
    $$stop(diff: number) {
      this.translate += diff;
      // 移动到最接近的那一行
      this.translate = Math.round(this.translate / this.rowHeight) * this.rowHeight;
      const max = getMax(this.offset, this.rowHeight);
      const min = getMin(this.offset, this.rowHeight, this.items.length);
      // 不要超过最大值或者最小值
      if (this.translate > max) {
        this.translate = max;
      }
      if (this.translate < min) {
        this.translate = min;
      }

      // 如果是 disabled 的就跳过
      let index = this.offset - this.translate / this.rowHeight;
      while (!!this.items[index] && this.items[index].disabled) {
        // eslint-disable-next-line no-plusplus
        diff > 0 ? ++index : --index;
      }
      this.translate = (this.offset - index) * this.rowHeight;
      this.setTransition(0.3);
      this.setTranslate(this.translate);

      // 触发选择事件
      this.onChange.call(this, this.items[index], index);
    },
    onTouchstart(e: TouchEvent) {
      this.$$start(e.changedTouches[0].pageY);
    },
    onTouchMove(e: TouchEvent) {
      this.$$move(e.changedTouches[0].pageY);
      e.preventDefault();
    },
    onTouchEnd(e: TouchEvent) {
      this.$$end(e.changedTouches[0].pageY);
    },
  },
});
